export const discussionTags = [
  "全部讨论",
  "证据链",
  "截图校对",
  "切片逐句",
  "声明拆解",
  "时间线对齐",
  "澄清帖",
];

export type DiscussionPost = {
  id: string;
  title: string;
  excerpt: string;
  tag: string;
  author: string;
  role: string;
  replies: number;
  views: string;
  likes: number;
  level: string;
  pinned?: boolean;
};

export const discussionPosts: DiscussionPost[] = [
  {
    id: "d1",
    title: "「雨下主播」实锤帖逐帧校对：截图时间线与口述对不上",
    excerpt:
      "把原帖中三张关键截图的时间戳与当事人直播切片逐帧比对，发现其中至少两处窗口时间存在明显错位，特此开帖供大家共同核验。",
    tag: "截图校对",
    author: "铁证整理员",
    role: "认证深挖员",
    replies: 1284,
    views: "18.6万",
    likes: 9200,
    level: "高采纳",
    pinned: true,
  },
  {
    id: "d2",
    title: "二次声明里那处措辞改动，可能就是最大的实锤",
    excerpt:
      "对照前后两版声明，「鉴于」与「基于」之间一个字的调整，连带删掉的那句话，放在完整时间线里看意义完全不一样。",
    tag: "声明拆解",
    author: "公关观察员",
    role: "深挖组外援",
    replies: 863,
    views: "12.4万",
    likes: 6400,
    level: "热帖",
  },
  {
    id: "d3",
    title: "切片逐句回看：直播里那句口误究竟是口误还是破绽",
    excerpt:
      "同一段直播切片被反复回放，在「我去看看」之后长达三秒的停顿被单独剪出，评论区对这句解读分成两派，我把完整语境补上。",
    tag: "切片逐句",
    author: "切片考古机",
    role: "认证深挖员",
    replies: 541,
    views: "9.1万",
    likes: 4300,
    level: "高采纳",
  },
  {
    id: "d4",
    title: "澄清帖：流传最广的那张聊天截图是假的，已附反证",
    excerpt:
      "这张被转了上万次的截图，实际是去年旧帖拼接而来。我用账号主页快照和服务器返回时间戳给出反向证据，希望大家转发前先核验。",
    tag: "澄清帖",
    author: "反假料联盟",
    role: "防误导志愿者",
    replies: 402,
    views: "7.8万",
    likes: 5100,
    level: "防误导",
  },
  {
    id: "d5",
    title: "实锤还是巧合：三次回应都卡在「上线时间点」附近",
    excerpt:
      "把三次回应与其账号的上线时间放在一起，会发现每次都在直播高峰前发布。是刻意安排还是巧合，欢迎从完整时间线角度补充。",
    tag: "时间线对齐",
    author: "规律观察员",
    role: "深挖组外援",
    replies: 315,
    views: "5.3万",
    likes: 2800,
    level: "热帖",
  },
  {
    id: "d6",
    title: "证据链汇总楼：所有实锤帖与反证按时间线归档",
    excerpt:
      "为避免讨论失焦，把目前公认度较高的实锤帖、争议帖与反证帖统一归档到一条时间线上，新增证据请在本楼补充。",
    tag: "证据链",
    author: "归档管理员",
    role: "认证深挖员",
    replies: 208,
    views: "4.7万",
    likes: 1900,
    level: "高采纳",
    pinned: true,
  },
];